export type HeaderFontSize = {
  $fontSize: number;
};

export const getTemplateHeaderFontSize = ({
  textLength,
  resizeAfterIndex,
  max,
  min,
}: {
  textLength: number;
  resizeAfterIndex: number;
  max: number;
  min: number;
}): HeaderFontSize => {
  const fontSize = Math.min(
    max,
    Math.max(min, Math.abs(max + resizeAfterIndex - textLength))
  );

  return {
    $fontSize: fontSize,
  };
};
